import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface SearchRejectedProps {
  reason: string;
  onReset: () => void;
}

export function SearchRejected({ reason, onReset }: SearchRejectedProps) {
  return (
    <Card aria-live="assertive" className="bg-background/40">
      <CardContent className="space-y-4 py-5">
        <div className="space-y-1">
          <p className="text-sm font-medium text-foreground">Search unavailable</p>
          <p className="text-sm text-muted-foreground">{reason}</p>
        </div>
        <Button variant="outline" onClick={onReset}>
          Back to search
        </Button>
      </CardContent>
    </Card>
  );
}
